import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { IRental } from "@/models/rental.entity";
import rentalService from "@/services/mrfiktiv/services/rental.service";
import { MrfiktivRentalControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const RentalPageDataProvider = new (class extends AbstractPageDataProvider<
  IRental,
  MrfiktivRentalControllerGetParamsGen
> {
  itemsPerPage = 25;

  async getPage(query: MrfiktivRentalControllerGetParamsGen): Promise<IPageViewModel<IRental>> {
    const res = await rentalService.getAll(query);

    const meta = res.meta;
    const data = (res.data ?? []) as IRental[];

    return { meta, data };
  }
})();
